import { useCallback, useMemo } from "react"
import { useQuery } from "urql"

import "@/screens/Companies/edit/components/preferences/graphql/shipFromPreference.query"

import { ShipFromPreferenceListDocument, type ShipFromPreferenceListQuery } from "@/graphql/codegen/graphql"

interface UseGetShipFromTransitDaysReturn {
  getTransitDays: (shipFromWarehouseId: string | null) => number | null
  isFetching: boolean
}

export const useGetShipFromTransitDays = (shipToLocationId: string): UseGetShipFromTransitDaysReturn => {
  const [{ data, fetching }] = useQuery<ShipFromPreferenceListQuery>({
    query: ShipFromPreferenceListDocument,
    variables: { input: { filter: { shipToLocationId } } },
    pause: !shipToLocationId,
  })

  const output = data?.shipFromPreference.list

  const transitDaysByWarehouseId = useMemo(() => {
    const map = new Map<string, number | null>()
    if (output?.__typename !== "ShipFromPreferenceListSuccess") return map

    output.shipFromPreferences.forEach((preference) => {
      map.set(preference.shipFromWarehouseId, preference.estimatedTransitDays ?? null)
    })
    return map
  }, [output])

  const getTransitDays = useCallback(
    (shipFromWarehouseId: string | null): number | null => {
      if (!shipFromWarehouseId) return null
      return transitDaysByWarehouseId.get(shipFromWarehouseId) ?? null
    },
    [transitDaysByWarehouseId]
  )

  return { getTransitDays, isFetching: fetching }
}
